"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtomComponent = void 0;
var ButtomComponent_1 = require("./ButtomComponent");
Object.defineProperty(exports, "ButtomComponent", { enumerable: true, get: function () { return __importDefault(ButtomComponent_1).default; } });
